import { Component, OnInit } from '@angular/core';
import { TwoFactorService } from '../../../service/two-factor.service';
import { NbToastrService } from '@nebular/theme';
import { UserStore } from 'src/app/deebr/store/user.store';

@Component({
    selector: 'app-deebr-profile',
    templateUrl: './deebr-profile.component.html',
    styleUrls: ['./deebr-profile.component.scss'],
    standalone: false
})
export class DeebrProfileComponent implements OnInit {
    is2FAEnabled: boolean = false;
    qrCode: string | null = null;
    secret: string | null = null;
    otpUri: string | null = null;
    verificationCode: string = '';

    constructor(
        private twoFactorService: TwoFactorService,
        private toastrService: NbToastrService,
        private userStore: UserStore
    ) { }

    ngOnInit(): void {
        // Check current user status
        this.userStore.select((state) => state.user).subscribe((user: any) => {
            if (user) {
                this.is2FAEnabled = user.is_2fa_enabled;
            }
        });
    }

    setup2FA() {
        this.twoFactorService.setup2FA(null).subscribe({
            next: (res) => {
                this.qrCode = res.qr_code;
                this.secret = res.secret;
                this.otpUri = res.otp_uri;
            },
            error: (err) => {
                this.toastrService.danger('Erreur lors de la configuration de la double authentification', 'Erreur');
            }
        });
    }

    confirm2FA() {
        if (!this.verificationCode) return;

        this.twoFactorService.confirm2FA(null, this.verificationCode).subscribe({
            next: (res) => {
                this.toastrService.success('La double authentification a été activée.', 'Succès');
                this.is2FAEnabled = true;
                this.qrCode = null; // Clear sensitive data
                this.secret = null;
                this.verificationCode = '';

                // Refresh user store usually needed here, or manually update local user object if store allows
                // Assuming user store re-fetches or we can trick it? 
                // For now, local state update is enough for UI feedback.
            },
            error: (err) => {
                this.toastrService.danger('Code incorrect.', 'Erreur');
            }
        });
    }

    disable2FA() {
        this.twoFactorService.disable2FA().subscribe({
            next: (res) => {
                this.toastrService.success('La double authentification a été désactivée.', 'Succès');
                this.is2FAEnabled = false;
            },
            error: (err) => {
                this.toastrService.danger('Erreur lors de la désactivation.', 'Erreur');
            }
        });
    }
}
